import { DatePipe } from '@angular/common';
import {
  Pipe,
  PipeTransform,
  Injectable,
  Inject,
  LOCALE_ID
} from '@angular/core';

@Pipe({ name: 'validDate' })
@Injectable()
export class ValidDatePipe extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) locale: string) {
    super(locale);
  }

  transform(value: string, arg0?: string): any {
    try {
      return super.transform(value, arg0);
    } catch (e) {
      return value;
    }
  }
}
